/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { metricsGetApiV3MetricsTotalRewardableNodesCount } from "../../funcs/metricsGetApiV3MetricsTotalRewardableNodesCount.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations
    .GetApiV3MetricsTotalRewardableNodesCountRequest$inboundSchema.optional(),
};

export const tool$metricsGetApiV3MetricsTotalRewardableNodesCount:
  ToolDefinition<typeof args> = {
    name: "metrics-get-api-v3-metrics-total-rewardable-nodes-count",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await metricsGetApiV3MetricsTotalRewardableNodesCount(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
